import apiClient from "@/shared/api/apiClient2";

export const getNotarialList = async (params) => {
  try {
    const { data } = await apiClient.get("/transactions", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getNotarialList failed", e);
  }
};

export const getNotarialItem = async (id) => {
  try {
    const { data } = await apiClient.get(`/transactions/${id}/`);
    return data;
  } catch (e) {
    console.error("getNotarialItem failed", e);
  }
};

export const createNotarial = async (code, params) => {
  const result = await apiClient.post(`/transactions/submit/${code}`, {
    ...params,
  });
  return result.data;
};

export const updateNotarial = async (id, params, isNotifyDisabled) => {
  const { data } = await apiClient.put(
    `/transactions/${id}`,
    {
      ...params,
    },
    {
      metaData: { isNotificationDisabled: isNotifyDisabled },
    }
  );
  return data;
};

export const removeNotarial = async (id) => {
  const { data } = await apiClient.delete(`/transactions/${id}`);
  return data;
};

export const setNotarialEndDate = async (tx_id, params) => {
  const { data } = await apiClient.put(`/transactions/${tx_id}/set-end-date`, {
    ...params,
  });
  return data;
};

export const getParticipantListNotarial = async (tx_id) => {
  try {
    const { data } = await apiClient.get(`/participants/${tx_id}`);
    return data;
  } catch (e) {
    console.error("getParticipantListNotarial failed", e);
  }
};

export const addParticipantToNotary = async (tx_id, params) => {
  const result = await apiClient.post(`/participants/${tx_id}`, {
    ...params,
  });
  return result.data;
};

export const updateParticipantNotarial = async (
  tx_id,
  participant_uuid,
  params
) => {
  const { data } = await apiClient.put(
    `/participants/${tx_id}/${participant_uuid}`,
    {
      ...params,
    }
  );
  return data;
};

export const removeParticipantNotarial = async (tx_id, participant_uuid) => {
  const { data } = await apiClient.delete(
    `/participants/${tx_id}/${participant_uuid}`
  );
  return data;
};

//

export const getDocumentListNotarial = async (tx_id) => {
  try {
    const { data } = await apiClient.get(`/documents/${tx_id}`);
    return data;
  } catch (e) {
    console.error("getDocumentListNotarial failed", e);
  }
};

export const addDocumentToNotary = async (tx_id, params) => {
  const result = await apiClient.post(`/documents/${tx_id}`, {
    ...params,
  });
  return result.data;
};

export const updateDocumentNotarial = async (tx_id, doc_uuid, params) => {
  const { data } = await apiClient.put(`/documents/${tx_id}/${doc_uuid}`, {
    ...params,
  });
  return data;
};

export const removeDocumentNotarial = async (tx_id, doc_uuid) => {
  const { data } = await apiClient.delete(`/documents/${tx_id}/${doc_uuid}`);
  return data;
};

export const getAiCheckResult = async (tx_id, config) => {
  try {
    const { data } = await apiClient.get(`/documents/${tx_id}`, config);
    return data;
  } catch (e) {
    if (e?.code === "ERR_CANCELED" || e?.name === "CanceledError") return null;
    console.error("getAiCheckResult error:", e);
    return null;
  }
};

export const triggerAiCheck = async (tx_id) => {
  try {
    const { data } = await apiClient.post(`/documents/${tx_id}/ai-check`);
    return data;
  } catch (e) {
    console.error("triggerAiCheck error:", e);
    return {
      success: false,
      error: e?.response?.data || e?.message || String(e),
    };
  }
};

export const updateNotarialNote = async (tx_id, note) => {
  const { data } = await apiClient.put(`/transactions/${tx_id}/note`, {
    note,
  });
  return data;
};

export const updateNotarialDescription = async (tx_id, description) => {
  const { data } = await apiClient.put(`/transactions/${tx_id}/description`, {
    description,
  });
  return data;
};

// export const uploadDocumentToNotary = async (tx_id, formData) => {
//   const result = await apiClient.post(
//     `/transactions/${tx_id}/documents/upload`,
//     formData
//   );
//
//   return result.data;
// };

export const getTransactionCurrent = async (params) => {
  try {
    const { data } = await apiClient.get("/transactions/current", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getTransactionCurrent failed", e);
  }
};

export const getTransactionLinks = async (params) => {
  try {
    const { data } = await apiClient.get("/links", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getTransactionLinks failed", e);
  }
};

export const createTransactionLink = async (params) => {
  const result = await apiClient.post(`/links`, {
    ...params,
  });
  return result.data;
};

export const updateNotarialLink = async (link_id, params) => {
  const { data } = await apiClient.put(`/links/${link_id}`, {
    ...params,
  });
  return data;
};

export const removeNotarialLink = async (link_id) => {
  const { data } = await apiClient.delete(`/links/${link_id}`);
  return data;
};

export const getParticipantNotarialList = async (params) => {
  try {
    const { data } = await apiClient.get("/participants/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getParticipantNotarialList failed", e);
  }
};

export const changeStatusNotarialAction = async (tx_id, params) => {
  const { data } = await apiClient.put(`/transactions/${tx_id}/status`, {
    ...params,
  });
  return data;
};

export const getParticipantListRecent = async () => {
  try {
    const { data } = await apiClient.get(`/participants/recent`);
    return data;
  } catch (e) {
    console.error("getParticipantListRecent failed", e);
  }
};

export const getAvailableActions = async ({
  transactionId,
  applicationUuid,
} = {}) => {
  const params = {};
  if (transactionId != null) params.transaction_id = transactionId;
  if (applicationUuid) params.application_uuid = applicationUuid;
  try {
    const { data } = await apiClient.get("/available-actions", { params });
    return { success: true, payload: data?.payload ?? data };
  } catch (e) {
    return { success: false, error: e };
  }
};
